import GuestbookForm from "./GuestbookForm";

export default function Comment(props) {
  return (
    <div style={{ margin: "0.1%", border: "2px solid silver" }}>
      <h2>{props.comment.nimi}</h2>
      {!props.modifyPost[props.comment.id] ? (
        <p>{props.comment.viesti}</p>
      ) : (
        <div>
          <textarea
            rows={5}
            defaultValue={props.comment.viesti}
            onChange={(e) => props.setTempMessage(e.target.value)}
          />
          <div>
            <button
              onClick={() =>
                props.handleSaveModify(
                  props.comment.id,
                  props.tempMessage,
                  props.comment.linkitys
                )
              }
            >
              Tallenna
            </button>
            <button onClick={() => props.handleModify(props.comment.id)}>
              Peruuta
            </button>
          </div>
        </div>
      )}

      {props.comment.nimi === props.nickname &&
      props.isHuman &&
      !props.modifyPost[props.comment.id] ? (
        <>
          <button
            onClick={() =>
              props.handleDelete(props.comment.id, props.comment.linkitys)
            }
          >
            Poista
          </button>
          <button
            onClick={() =>
              props.handleModify(props.comment.id, props.comment.viesti)
            }
          >
            Muokkaa
          </button>
        </>
      ) : props.isMember &&
        props.isHuman &&
        !props.modifyPost[props.comment.id] ? (
        <div>
          <button
            onClick={() =>
              props.handleDelete(props.comment.id, props.comment.linkitys)
            }
          >
            Poista
          </button>

          {props.comment.ihminen ? (
            <button
              onClick={() =>
                props.handleBanUser(props.comment.nimi, props.comment.ihminen)
              }
            >
              Laita käyttäjä arestiin
            </button>
          ) : (
            <button
              onClick={() =>
                props.handleBanUser(props.comment.nimi, props.comment.ihminen)
              }
            >
              Poista aresti
            </button>
          )}
        </div>
      ) : null}

      <p style={{ color: "gray" }}>
        Lähetetty: {new Date(props.comment.aika).toLocaleString()}
      </p>
      {props.comment.muokattu !== null ? (
        <p>Muokattu: {new Date(props.comment.muokattu).toLocaleString()}</p>
      ) : null}

      {!props.writeComment[props.comment.id] ? (
        <div>
          <button onClick={() => props.handleWriteComment(props.comment.id)}>
            Kommentoi
          </button>
          {props.comment.kommentit > 0 ? (
            <button onClick={() => props.handleOpenComments(props.comment.id)}>
              Kommentit: {props.comment.kommentit}
            </button>
          ) : (
            ""
          )}
        </div>
      ) : (
        <div>
          <GuestbookForm
            refreshPosts={props.refreshPosts}
            refreshComments={props.refreshComments}
            refreshParent={props.refreshParent}
            userId={props.userId}
            setUserId={props.setUserId}
            nickname={props.nickname}
            setNickname={props.setNickname}
            saveUserId={props.saveUserId}
            saveUserName={props.saveUserName}
            saveUserToken={props.saveUserToken}
            savedToken={localStorage.getItem("minebikers_token")}
            linkitys={props.comment.id}
            isHuman={props.isHuman}
            onCommentSubmit={() => {
              props.handleWriteComment(props.comment.id);
              props.setShowComments((prev) => ({
                ...prev,
                [props.comment.id]: true,
              }));
            }}
          />
          <button onClick={() => props.handleWriteComment(props.comment.id)}>
            Sulje
          </button>
        </div>
      )}
      {props.showComments[props.comment.id] &&
        props.comments[props.comment.id] && (
          <div>
            {props.comments[props.comment.id].length > 0
              ? props.comments[props.comment.id].map((nestedComment) => (
                  <Comment
                    key={nestedComment.id}
                    comment={nestedComment}
                    nickname={props.nickname}
                    isMember={props.isMember}
                    isHuman={props.isHuman}
                    userId={props.userId}
                    setUserId={props.setUserId}
                    setNickname={props.setNickname}
                    saveUserId={props.saveUserId}
                    saveUserName={props.saveUserName}
                    saveUserToken={props.saveUserToken}
                    savedToken={localStorage.getItem("minebikers_token")}
                    refreshPosts={props.refreshPosts}
                    refreshComments={props.refreshComments}
                    refreshParent={props.refreshParent}
                    handleDelete={props.handleDelete}
                    handleModify={props.handleModify}
                    handleSaveModify={props.handleSaveModify}
                    modifyPost={props.modifyPost}
                    setModifyPost={props.setModifyPost}
                    handleBanUser={props.handleBanUser}
                    handleWriteComment={props.handleWriteComment}
                    handleOpenComments={props.handleOpenComments}
                    writeComment={props.writeComment}
                    showComments={props.showComments}
                    setShowComments={props.setShowComments}
                    comments={props.comments}
                    tempMessage={props.tempMessage}
                    setTempMessage={props.setTempMessage}
                    onCommentSubmit={() => {
                      props.handleWriteComment(nestedComment.id);
                      props.setShowComments((prev) => ({
                        ...prev,
                        [nestedComment.id]: true,
                      }));
                    }}
                  />
                ))
              : ""}
          </div>
        )}
    </div>
  );
}
